var React = require('react');

function SuitableIndoor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0, .st1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .st1 {\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("polyline",{"className":"st1","points":"7.8 19 7.8 60.4 60.3 60.4 60.3 19","key":1}),React.createElement("polyline",{"className":"st1","points":"1.7 21 34.5 7.9 66.5 21","key":2}),React.createElement("polyline",{"className":"st1","points":"25 29.2 29.2 46.3 43.9 46.3 43.9 60.4","key":3}),React.createElement("line",{"className":"st0","x1":"25","y1":"60.4","x2":"29.2","y2":"46.3","key":4})]);
}

SuitableIndoor.defaultProps = {"id":"Capa_2","version":"1.1","viewBox":"0 0 68.3 68.3"};

module.exports = SuitableIndoor;

SuitableIndoor.default = SuitableIndoor;
